import { Controller } from "@hotwired/stimulus"

// Keeps a form's commit behind its named button. Text fields otherwise
// submit implicitly on Enter in some browsers; multiline fields opt out by
// simply not wiring this action.
export default class extends Controller {
  prevent(event) {
    event.preventDefault()
  }
}
